<script lang="js">
import { models } from '@/lib/schema'
import AdminEditBasePage from '@/pages/admin/edit/Base'
import { Logger } from '@/lib/logger'
import { preprocessActions } from '@/lib/util'

export default {
  name: 'AdminEditPage',
  functional: true,
  mixins: [],
  components: {},
  props: {
    post: Object,
    // actions: String,
    // groupActions: Array,
  },
  render( h, ctx ) {
    // const { post, actions, groupActions } = ctx.props
    const { post } = ctx.props
    const { model } = post
    const modelObject = models[ model ]
    const component = ( modelObject && modelObject.components &&
                        modelObject.components.edit( post )) || AdminEditBasePage
    Logger.debug( 'ctx', '<AdminEditPage>', ctx )()
    ctx.data.attrs.model = modelObject
    ctx.data.attrs.post = post
    // if ( actions ) {
    //   ctx.data.attrs.actions = preprocessActions( actions, {
    //     model: modelObject,
    //   })
    // }
    // if ( groupActions ) {
    //   ctx.data.attrs.groupActions = preprocessActions( groupActions, {
    //     model: modelObject,
    //   })
    // }
    return h( component, ctx.data, ctx.children )
  }
}
</script>

<style lang="scss">
.admin-edit {
}
</style>
